import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { getStmBrands } from 'features/all-brands/ducks/get-brands';
import { StmSection } from 'features/stm-section';
import { FadeButton } from 'features/fade-button';
import { fadeButtonOpened, fadeContainer, StmContainer, stmContainerOpened, stmHeader } from './styles';

export const StmBrands: React.FC = () => {
  const { t } = useTranslation();
  const [isOpened, setOpened] = useState(false);

  const stmBrands = useSelector(getStmBrands);
  const handleClick = () => {
    setOpened(!isOpened);
  };
  const stmHeight = { height: `${isOpened ? 'initial' : ''}` };

  if (!stmBrands?.length) {
    return null;
  }

  return (
    <>
      <Typography variant="h2" className={stmHeader}>
        {t('stm')}
      </Typography>
      <StmContainer
        style={stmHeight}
        className={isOpened ? stmContainerOpened : undefined}
        data-qa="stm-container"
      >
        {stmBrands?.map((stm) => (
          <StmSection stm={stm} key={stm.label} />
        ))}
        {!isOpened && <div className={fadeContainer} />}
        <FadeButton
          open={isOpened}
          onClick={handleClick}
          className={isOpened ? fadeButtonOpened : undefined}
        />
      </StmContainer>
    </>
  );
};
